jQuery(function($) {

  window.categoryArchive = {}

  window.categoryArchive.ratingInit = function() {
    $('.recipe-rating').starRating({
      totalStars: 5,
      starSize: 18,
      strokeWidth: 25,
      strokeColor: '#E4b84A',
      emptyColor: '#FFFFFF',
      hoverColor: '#E4b84A',
      activeColor: '#E4b84A',
      useGradient: false,
      readOnly: true
    })
  }

  window.categoryArchive.more = function() {

    let $this = $(this)

    $this
      .attr('disabled', 'disabled')
      .addClass('loading')

    $.get( $this.data('url'), function( data, status ) {
      content = $( $.parseHTML( data ) ).find('#recipes').html()
      $this
        .parent()
        .replaceWith( content )

      window.categoryArchive.observer()
    })
  }

  window.categoryArchive.observerCallback = function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let $currentGroup = $(entry.target)
        let $meta = $('meta[name=robots]')
        let title = $('title').text().split('|')[0] + ' | ' + 'Page ' + $currentGroup.data('paged') + ' of ' + $currentGroup.data('total-pages') + ' | Recipes.net'

        $('title').html(title)

        window.categoryArchive.ratingInit()
        window.history.pushState({ state: $currentGroup.data('paged') }, title, url.current + '/page/' + $currentGroup.data('paged') + '/')

        if( $currentGroup.data('paged') > 1 ) {
          $meta.attr( 'content', 'noindex, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' )
        } else {
          $meta.attr( 'content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' )
        }
      }
    })
  }

  window.categoryArchive.observer = function() {
    if ('IntersectionObserver' in window) {
      let groups = document.querySelectorAll('.recipe-group')
      let object = new IntersectionObserver(
        window.categoryArchive.observerCallback
      )
      for (const group of groups) {
        object.observe(group)
      }
    }
  }

  window.categoryArchive.eventListeners = function() {
    window.categoryArchive.ratingInit()
    window.categoryArchive.observer()
    $('body').on('click', '.more-recipes', window.categoryArchive.more)
  }

  window.categoryArchive.eventListeners()
})



// WEBPACK FOOTER //
// ./src/js/category-archive.js